import React from 'react'
import "./Fondamentaux.css"

const Fondamentaux = () => {
    return (
        <img src="https://zupimages.net/up/22/11/n5tj.jpg" alt="Les 8 fondamentaux d'Enedis" className='imageFondamentaux' />
    )
}

export default Fondamentaux;